import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "../../../store/store";

export interface ProgressState {
  darkMode: boolean;
  // number of completed CLI commands
  bulkCloneCount: number;
}

const initialState: ProgressState = {
  darkMode: false,
  bulkCloneCount: 0,
};

const cloneProgressReducer = createSlice({
  name: "cloneProgress",
  initialState,
  reducers: {
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        darkMode: action.payload,
      };
    },
    setBulkCloneCount: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        bulkCloneCount: action.payload,
      };
    },
  },
});

export const { setDarkMode, setBulkCloneCount } = cloneProgressReducer.actions;

export const getDarkMode = (state: RootState): boolean => state.cloneProgress.darkMode;

export const getBulkCloneCount = (state: RootState): number => state.cloneProgress.bulkCloneCount;
export default cloneProgressReducer.reducer;
